import SurveyTracker from './SurveyTracker.vue';

export default SurveyTracker;
